import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch, RootState } from '../store'

const REPORTING_REQUEST = 'REPORTING_REQUEST'
const REPORTING_SUCCESS = 'REPORTING_SUCCESS'
const REPORTING_ERROR = 'REPORTING_ERROR'
export const REPORTING_RESET = 'REPORTING_RESET'

interface ReportingRequestAction {
  type: typeof REPORTING_REQUEST
}

interface ReportingSuccessAction {
  type: typeof REPORTING_SUCCESS
  payload: Reporting
}

interface ReportingErrorAction {
  type: typeof REPORTING_ERROR
  payload: string
}

type ReportingActionTypes =
  | ReportingRequestAction
  | ReportingSuccessAction
  | ReportingErrorAction

export const fetchReports =
  (start: MaterialUiPickersDate, end: MaterialUiPickersDate) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: REPORTING_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const token = (userInfo as User).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.get(`/api/reporting/${start}/${end}`, config)

      return dispatch({
        type: REPORTING_SUCCESS,
        payload: data,
      })
    } catch (err) {
      const error = err as AxiosError

      return dispatch({
        type: REPORTING_ERROR,
        payload: error.message,
      })
    }
  }

interface InitialState {
  data: Reporting
  error: string
  loading: boolean
  success: boolean
}

const initialState: InitialState = {
  data: {
    closeWon: undefined,
    closeLost: undefined,
    submitted: undefined,
    unconverted: undefined,
    unassigned: undefined,
  },
  error: '',
  loading: false,
  success: false,
}

export const reportingReducer = (
  state = initialState,
  action: ActionWithPayload<ReportingActionTypes>
) => {
  switch (action.type) {
    case REPORTING_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      }
    case REPORTING_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: '',
        success: true,
        loading: false,
      }
    case REPORTING_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case REPORTING_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
